// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2E3Xb","content":"GlobalSearch_content__2vcGR"};